"use client";
import { jsxs as B, jsx as a } from "react/jsx-runtime";
import { useState as f } from "react";
import { Close as q, Search as A } from "@videoblocks/react-icons";
import { MediaSelect as E } from "../../molecules/MediaSelect/MediaSelect.mjs";
import { MediaSelectContent as F } from "../../molecules/MediaSelect/MediaSelectContent.mjs";
import { MediaSelectItem as G } from "../../molecules/MediaSelect/MediaSelectItem.mjs";
import { Input as H } from "../../atoms/Input/Input.mjs";
import { IconButton as p } from "../../atoms/IconButton/IconButton.mjs";
import { cn as J } from "../../../utils/utils.mjs";
const O = ({
  value: d,
  defaultValue: v,
  onChange: t,
  placeholder: x,
  autoFocus: k,
  "aria-label": g = "Search",
  onSubmit: o,
  onClose: w,
  showClose: S = !1,
  selectOptions: r,
  selectValue: n,
  defaultSelectValue: i,
  onSelectChange: c,
  submitAriaLabel: V = "Submit search",
  className: I,
  ...N
}) => {
  var h, b;
  const [y, P] = f(v ?? ""), s = d !== void 0, u = s ? d : y, [M, j] = f(i), l = n !== void 0, m = l ? n : M, z = !!r && r.length > 0, C = ((h = r == null ? void 0 : r.find(({ value: e }) => e === m)) == null ? void 0 : h.placeholder) ?? x, D = (e) => {
    s || P(e.target.value), t == null || t(e);
  }, L = (e) => {
    l || j(e), c == null || c(e);
  };
  return /* @__PURE__ */ B(
    "form",
    {
      role: "search",
      onSubmit: (e) => {
        e.preventDefault(), o == null || o({ value: u, selectValue: m });
      },
      className: J(
        "flex h-11 w-full max-w-[343px] items-center gap-3 rounded-[999px] bg-neutral-dark-200 px-1 md:max-w-[1032px]",
        I
      ),
      children: [
        z && /* @__PURE__ */ a(
          E,
          {
            value: l ? n : void 0,
            defaultValue: l ? void 0 : i,
            onValueChange: L,
            placeholder: ((b = r[0]) == null ? void 0 : b.label) ?? "Select",
            className: "h-9 min-w-[90px] gap-2 bg-neutral-dark-100 px-3 py-2 text-sm text-white hover:border-transparent hover:bg-neutral-dark-200",
            children: /* @__PURE__ */ a(F, { children: r.map((e) => /* @__PURE__ */ a(
              G,
              {
                value: e.value,
                icon: e.icon,
                selectItemLabel: e.selectItemLabel,
                children: e.label
              },
              e.value
            )) })
          }
        ),
        /* @__PURE__ */ a(
          H,
          {
            type: "search",
            tone: "dark",
            value: u,
            onChange: D,
            placeholder: C,
            autoFocus: k,
            "aria-label": g,
            className: "h-10 flex-1 rounded-[999px] border-0 bg-neutral-dark-200 px-2 text-base font-normal text-neutral-dark-1000 placeholder:text-neutral-dark-700 focus:ring-0 focus:outline-none [&::-webkit-search-cancel-button]:hidden",
            ...N
          }
        ),
        S ? /* @__PURE__ */ a(
          p,
          {
            type: "button",
            variant: "secondary",
            size: "small",
            "aria-label": "Close search",
            onClick: w,
            icon: /* @__PURE__ */ a(q, { className: "fill-white" }),
            className: "bg-neutral-dark-100 hover:bg-neutral-dark-400"
          },
          "close"
        ) : /* @__PURE__ */ a(
          p,
          {
            type: "submit",
            variant: "secondary",
            size: "small",
            "aria-label": V,
            icon: /* @__PURE__ */ a(A, { className: "fill-white" }),
            className: "bg-neutral-dark-100 hover:bg-neutral-dark-400"
          },
          "submit"
        )
      ]
    }
  );
};
export {
  O as ProminentSearch
};
